import { Badge, Space } from "antd";
import { useTranslation } from "react-i18next";
import { useTheme } from "antd-style";
import { VitriaIcon } from '@/components/VitriaIcon';

const STATUS = {
  creating: {
    render: (label) => {
      return (<>
        <Badge status="processing" />
        <span>{label}</span>
      </>);
    },
  },
  running: {
    render: (label) => {
      return (<>
        <Badge status="success" />
        <span>{label}</span>
      </>);
    },
  },
  'create-failed': {
    render: (label, token) => {
      return (<>
        <VitriaIcon type="vicon-error" style={{ color: token.colorError }} />
        <span>{label}</span>
      </>);
    },
  },
  stopping: {},
  'stop-failed': {},
  stopped: {
    render: (label) => {
      return (<>
        <Badge status="error" />
        <span>{label}</span>
      </>);
    },
  },
  starting: {},
  'start-failed': {},
  'scaling-up': {},
  'scaleup-failed': {},
  'scaling-down': {},
  'scaled-down': {},
  'scaledown-failed': {},
  deleting: {
    render: (label) => {
      return (<>
        <Badge status="processing" />
        <span>{label}</span>
      </>);
    }
  },
  delete_failed: {},
  upgrading: {
    render: (label) => {
      return (<>
        <Badge status="processing" />
        <span>{label}</span>
      </>);
    }
  },
  "upgrade-failed": {
    render: (label, token) => {
      return (<>
        <VitriaIcon type="vicon-error" style={{ color: token.colorError }} />
        <span>{label}</span>
      </>);
    },
  },
};
// TODO: Enhance the InstanceStatus component to display the status in a more user-friendly way. 
// The status should be displayed in a different color depending on the status.
export const InstanceStatus = ({ status }) => {
  const { t } = useTranslation();
  const token = useTheme();
  let content = t(`instances.statusLabel.${status}`, status);
  if (STATUS[status] && STATUS[status].render) {
    content = STATUS[status].render(content, token);
  }
  return (<Space>{content}</Space>);
};